import React from 'react';
import { PatientManualRegistrationParams } from '../PatientManualRegistration';
import PatientManualRegistrationLatamForm, {
	PatientManualRegistrationLatamFormValues,
} from './PatientManualRegistrationLatamForm';
import useWorkplacePatient, {
	PatientData,
} from '../../../Hooks/useWorkplacePatient';
import useFilters from '../../../../Base/Hooks/useFilters';
import useHelpers from '../../../../Base/Hooks/useHelpers';

interface Props {
	workplaceId: string;
	onSuccess?: (params: PatientManualRegistrationParams) => void;
	setIsLoading: (isLoading: boolean) => void;
}
const PatientManualRegistrationLatam: React.FC<Props> = ({
	onSuccess,
	workplaceId,
	setIsLoading,
}) => {
	const { createPatient } = useWorkplacePatient();
	const { handleDateValue } = useFilters();
	const { handleString } = useHelpers();
	const handleLatamRegistrationSuccess = async (
		values: PatientManualRegistrationLatamFormValues,
		withHealthPlan: boolean,
	) => {
		setIsLoading(true);
		const data: PatientData = {
			sendEmailInvitation: true,
			patient: {
				salutationBefore: values.salutationBefore ?? undefined,
				firstName: values.firstName,
				middleName: values.middleName,
				motherLastName: values.motherLastName,
				fatherLastName: values.fatherLastName,
				lastName: values.lastName ?? undefined,
				contactPhoneNumber: values.phoneNumber ?? undefined,
				contactEmail: values.email,
				birthDate: handleDateValue(values.birthDate),
				gender: values.gender ?? undefined,
				identificationDocumentNumber:
					values.identificationDocumentNumber ?? undefined,
			},
			healthPlanCode: handleString(values.healthPlanCode?.value),
			legalRepresentative: values.legalRepresentative ?? undefined,
			healthPlanWorkplaceMemberId:
				values.healthPlanWorkplaceMember?.value ??
				values.healthPlanWorkplaceMember?.id ??
				undefined,
		};

		const patient: any = await createPatient(data, workplaceId);
		if (patient) {
			const parentId = null;
			if (
				withHealthPlan &&
				patient.data.userId &&
				data.healthPlanCode &&
				data.healthPlanWorkplaceMemberId
			) {
				//@ts-ignore
				window.location.href = `treatment/default/${patient.data.userId}?handle=createHealthPlan&params%5BhealthPlanCode%5D=${data.healthPlanCode}`;
				return;
			}
			onSuccess?.({
				patientId: patient.data.userId,
				parentId: parentId,
				withInvite: data.sendEmailInvitation,
			});
		}
		setIsLoading(false);
	};

	return (
		<PatientManualRegistrationLatamForm
			onSuccess={handleLatamRegistrationSuccess}
		/>
	);
};

export default PatientManualRegistrationLatam;
